import * as jQuery from 'jquery';
var $ = jQuery;
export function statementCalloutWidgetScripts() {
    $(document).ready(function () {
    });
}
